import { BotDetectionService, loadGTM, loadHotjar } from '@naturalcycles/js-lib/browser'
import type { AnyObject } from '@naturalcycles/js-lib/types'
import { isClientSideProd } from './env.js'

const botDetectionService = new BotDetectionService()

// oxlint-disable unicorn/prefer-global-this

const __gtagId = 'G-X7Q6VHE7JT'
const gtmId = 'GTM-N983ZCKG'

export function pageView(props?: AnyObject): void {
  // console.log(props)
  if (!isClientSideProd) return

  // window.gtag?.('event', 'page_view', {
  //   ...props,
  // })

  // todo: figure out how to filter the very first duplicated page_view
  const pageViewProps = {
    event: 'page_view',
    page_location: window.location.href,
    page_path: window.location.pathname,
    page_title: document.title,
    ...props,
  }
  // console.log({ pageViewProps })

  window.dataLayer?.push(pageViewProps)
}

export function setupAnalytics(): void {
  // Only do analytics in prod
  if (!isClientSideProd) return

  const enabled = !botDetectionService.isBotOrCDP()

  // void loadGTag(gtagId, enabled)
  void loadGTM(gtmId, enabled)

  // Don't load analytics for bots
  if (!enabled) return

  // Page views
  // https://developers.google.com/analytics/devguides/collection/ga4/views?client_type=gtag#manual_pageviews

  // window.gtag('config', gtagId, {
  //   send_page_view: false,
  // })

  loadHotjar(5155678)

  loadApollo()
}

function loadApollo(): void {
  // oxlint-disable
  const n = Math.random().toString(36).substring(7)
  const o = document.createElement('script')
  o.src = 'https://assets.apollo.io/micro/website-tracker/tracker.iife.js?nocache=' + n
  o.async = true
  o.defer = true
  o.onload = () => {
    window.trackingFunctions.onLoad({ appId: '66e04d6d7bef1603ef1ef4d0' })
  }
  document.head.appendChild(o)
  // oxlint-enable
}

declare global {
  interface Window {
    trackingFunctions?: any
  }
}

Object.assign(globalThis, {
  botDetectionService, // for debugging
})
